import React from 'react';
import { useTranslation } from 'react-i18next';
import './HowItWorks.css';

/**
 * HowItWorks - 5-step explainer section
 *
 * Props:
 * - None currently (static content)
 *
 * Features:
 * - Navy background section
 * - 5 cards: Read & Accept Terms, Select State, Upload, AI Analysis, Get Report
 * - Circular story images showing empowerment journey
 * - Step numbers
 * - Hover effects
 * - Responsive: stacks on mobile
 */
export function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    {
      id: 1,
      title: t('howItWorks.step1.title'),
      description: t('howItWorks.step1.description'),
      image: '/story_images/contract-signing.png',
      imageAlt: t('howItWorks.step1.imageAlt'),
    },
    {
      id: 2,
      title: t('howItWorks.step2.title'),
      description: t('howItWorks.step2.description'),
      image: '/story_images/lady-justice-scales.png',
      imageAlt: t('howItWorks.step2.imageAlt'),
    },
    {
      id: 3,
      title: t('howItWorks.step3.title'),
      description: t('howItWorks.step3.description'),
      image: '/story_images/signing-legal-documents.png',
      imageAlt: t('howItWorks.step3.imageAlt'),
    },
    {
      id: 4,
      title: t('howItWorks.step4.title'),
      description: t('howItWorks.step4.description'),
      image: '/story_images/laptop-teamwork.png',
      imageAlt: t('howItWorks.step4.imageAlt'),
    },
    {
      id: 5,
      title: t('howItWorks.step5.title'),
      description: t('howItWorks.step5.description'),
      image: '/story_images/document-review-notes.png',
      imageAlt: t('howItWorks.step5.imageAlt'),
    },
  ];

  return (
    <section className="how-it-works-section">
      <div className="how-it-works-container">
        <h2 className="section-title">{t('howItWorks.title')}</h2>
        <div className="steps-grid">
          {steps.map((step) => (
            <div key={step.id} className="step-card">
              <div className="step-number">{step.id}</div>
              <div className="step-image-container">
                <img
                  src={step.image}
                  alt={step.imageAlt}
                  className="step-image"
                />
              </div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
